/* ========================================================================== *\
    IMPORTS
\* ========================================================================== */

import { bind, forEach, isNil } from 'lodash';
import Mustache from "mustache";

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
    PRIVATE VARIABLES
\* ========================================================================== */

let
    givenAnswers = [],
    questionIndex = 0,
    prefix = ['a', 'b', 'c', 'd', 'e', 'f'];

const
    moduleName = 'exam-widget-exam',
    baseCssClass = `js-${moduleName}`,
    cssClasses = {
        hidden: 'hidden',
        validation: 'c-validation-error'
    },
    selectors = {
        base: `.${baseCssClass}`,
        newExamButton: `.${baseCssClass}-new-exam-button`,
        nextQuestionButton: `.${baseCssClass}-next-question-button`,
        pane: `.${baseCssClass}-pane`,
        previousQuestionButton: `.${baseCssClass}-previous-question-button`,
        resultButton: `.${baseCssClass}-result-button`,
        titleResult: `.${baseCssClass}-title-result`,
        validation: `.${baseCssClass}-validation`
    },
    templateQuestion = ` 
      <h2 class="c-widget__heading">{{examName}}</h2>
      {{#examNameRule}}      
        <h3 class="c-widget__sub-heading">{{examNameRule}}</h3>
      {{/examNameRule}}
      {{#checkShowResult}}
        <h3 class="c-widget__sub-heading">Uitslag: {{totalCorrectAnswers}} van de {{totalQuestions}} vragen goed beantwoord</h3>
      {{/checkShowResult}}
	  <fieldset> 
		<legend class="c-widget__text">Vraag {{questionNumber}} van {{totalQuestions}}</legend>
		<p>{{question}}</p>
        <div class="c-widget__question">
            <ul class="o-list-bare c-widget__question-answers {{^image}}is-1-column{{/image}}{{#image}}is-2-column{{/image}}">
            {{#answers}}
                <li>
                    <div class="c-radio-button {{#checkShowResult}}{{^currentCorrectAnswer}}is-incorrect{{/currentCorrectAnswer}}{{#currentCorrectAnswer}}is-correct{{/currentCorrectAnswer}}{{/checkShowResult}}">
                        <input type="radio" value="{{value}}" name="question" id="answer{{value}}" {{#checked}}checked{{/checked}} {{#checkShowResult}}disabled{{/checkShowResult}}>
                        <label for="answer{{value}}">
                            <span class="c-widget__answer-prefix">{{prefix}}</span>
                            {{text}}
                        </label>
                    </div>
                </li>
            {{/answers}}
            </ul>
            {{#image}}
                <div class="c-widget__question-image">
                    <img src="{{image}}">
                </div>
            {{/image}}
        </div>
        <div class="c-form__input__msg hidden js-exam-widget-exam-validation">Maak een keuze</div>
        {{#checkShowResult}}
            {{#explanation}}
                <h3 class="heading6">Uitleg</h3>
                <p>{{explanation}}</p>
            {{/explanation}}
        {{/checkShowResult}}
	  </fieldset>
    `;

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
    EVENT HANDLING
\* ========================================================================== */

function bindEvents() {
    if (
        this.nextQuestionButton === null ||
        this.pane === null ||
        this.previousQuestionButton === null ||
        this.resultButton === null ||
        this.newExamButton === null
    ) {
        return;
    }

    this.nextQuestionButton.addEventListener('click', bind(onClickNextQuestion, this));
    this.pane.addEventListener('change', bind(onChangeQuestion, this));
    this.previousQuestionButton.addEventListener('click', bind(onClickPreviousQuestion, this));
    this.resultButton.addEventListener('click', bind(onClickResult, this));
    this.newExamButton.addEventListener('click', bind(onClickNewExam, this));
}

function onChangeQuestion() {
    validate(this.pane);
}

function removeHash() {
    history.pushState("", document.title, window.location.pathname
        + window.location.search);
}

function onClickNewExam() {
    removeHash();
    window.location.reload();
}

function onClickNextQuestion() {
    if (validate(this.pane)) {
        storeGivenAnswers(questionIndex, givenAnswer(this.pane));
        questionIndex++;
        this.checkShowResults();
    }
}

function onClickPreviousQuestion() {
    questionIndex--;
    this.checkShowResults();
}

function onClickResult() {
    if (validate(this.pane)) {
        storeGivenAnswers(questionIndex, givenAnswer(this.pane));
        questionIndex = 0;
        this.checkShowResult = true;
        this.renderQuestion(this.checkShowResult);
        this.nextQuestionButton.classList.remove(cssClasses.hidden);
        this.resultButton.classList.add(cssClasses.hidden);
    }
}

/* == EVENT HANDLING ======================================================== */



/* ========================================================================== *\
    PRIVATE METHODS
\* ========================================================================== */

function compareAnswers(givenAnwsers, correctAnswers) {
    let
        totalCorrectAnswers = 0;

    forEach(correctAnswers, (correctAnswer, index) => {
        if (correctAnswer === givenAnwsers[index]) {
            totalCorrectAnswers++;
        }
    });

    return totalCorrectAnswers;
}


function getSelectedValue(pane) {
    const
        checkedItem = pane.querySelector('input:checked');

    return (checkedItem === null)
        ? null
        : parseInt(checkedItem.value, 10);
}

function givenAnswer(pane) {
    const
        chosenRadio = getSelectedValue(pane);

    return chosenRadio;
}

async function prefetch(url) {
    const img = await new Image();
    img.src = url;

    return url;
}

function storeGivenAnswers(index, value) {
    givenAnswers[index] = value;
}

function updateControls(totalQuestions, checkShowResult, nextQuestionButton, previousQuestionButton, resultButton, newExamButton) {
    if (
        nextQuestionButton === null ||
        previousQuestionButton === null ||
        resultButton === null ||
        newExamButton === null
    ) {
        return;
    }

    if (questionIndex == 0) {
        previousQuestionButton.disabled = true;
        nextQuestionButton.disabled = false;
    } else if ((questionIndex + 1) == totalQuestions) {
        if (checkShowResult == false) {
            nextQuestionButton.classList.add(cssClasses.hidden);
            resultButton.classList.remove(cssClasses.hidden);
        } else {
            nextQuestionButton.disabled = true;
            nextQuestionButton.classList.remove(cssClasses.hidden);
        }
    }
    else {
        if (checkShowResult == false) {
            previousQuestionButton.disabled = false;
            nextQuestionButton.classList.remove(cssClasses.hidden);
            resultButton.classList.add(cssClasses.hidden);
        } else {
            nextQuestionButton.disabled = false;
            nextQuestionButton.classList.remove(cssClasses.hidden);
            previousQuestionButton.disabled = false;
        }
    }

    if (checkShowResult == true) {
        newExamButton.classList.remove(cssClasses.hidden);
    }
}

function validate(pane) {
    const
        isValid = getSelectedValue(pane) !== null,
        validationText = document.querySelector(selectors.validation);

    if (!isValid) {
        validationText.classList.add(cssClasses.validation);
        validationText.classList.remove(cssClasses.hidden);
    } else {
        validationText.classList.add(cssClasses.hidden);
        validationText.classList.remove(cssClasses.validation);
    }
    return isValid;
}

/* == PRIVATE METHODS ======================================================= */



/* ========================================================================== *\
    PUBLIC API
\* ========================================================================== */

export class Exam {
    /* ====================================================================== *\
        CONSTRUCTOR
    \* ====================================================================== */

    constructor(baseElement) {
        if (isNil(baseElement)) {
            throw 'Unable to create instance of Exam, no base element has been provided';
        }

        this.baseElement = baseElement;
        this.checkShowResult = false;
        this.mediaItem = '';
        this.newExamButton = baseElement.querySelector(selectors.newExamButton);
        this.nextQuestionButton = baseElement.querySelector(selectors.nextQuestionButton);
        this.pane = baseElement.querySelector(selectors.pane);
        this.previousQuestionButton = baseElement.querySelector(selectors.previousQuestionButton);
        this.resultButton = baseElement.querySelector(selectors.resultButton);

        bindEvents.call(this);
    }

    /* == CONSTRUCTOR ======================================================= */

    /* ====================================================================== *\
        PUBLIC METHODS
    \* ====================================================================== */

    getCorrectAnswers() {
        const
            correctAnswers = new Array();

        forEach(this.exam.questions, item => {
            correctAnswers.push(item.correctAnswer);
        });

        return correctAnswers;
    }

    getTotalCorrectAnswers() {
        return compareAnswers(givenAnswers, this.getCorrectAnswers());
    }

    initExam(exam, examName, examNameRule) {
        this.exam = exam;
        this.examName = examName;
        this.examNameRule = examNameRule;
        this.totalQuestions = exam.questions.length;
        this.givenAnswers = new Array(exam.questions.length);
    }

    checkShowResults() {
        if (this.checkShowResult == false) {
            this.renderQuestion(false);
        } else {
            this.renderQuestion(true);
        }
    }

    renderQuestion(checkShowResult = false) {
        if (this.pane === null) {
            return false;
        }

        prefetch(this.exam.questions[questionIndex].imageUrl).then(imageUrl => {
            const
                originalQuestion = this.exam.questions[questionIndex].question,
                strippedQuestion = originalQuestion.replace(/(<([^>]+)>)/gi, ""),
                currentCorrectAnswer = this.exam.questions[questionIndex].correctAnswer,
                currentQuestion = this.exam.questions[questionIndex],
                newData = {
                    ...currentQuestion,
                    answers: currentQuestion.answers.map(answer => {
                        return {
                            ...answer,
                            checked: answer.value === givenAnswers[questionIndex],
                            currentCorrectAnswer: answer.value === currentCorrectAnswer,
                            prefix: prefix[answer.value - 1]
                        }
                    }),
                    checkShowResult: checkShowResult,
                    examName: this.examName,
                    examNameRule: this.examNameRule,
                    image: imageUrl,
                    question: strippedQuestion,
                    questionNumber: (questionIndex + 1),
                    totalQuestions: this.totalQuestions,
                    totalCorrectAnswers: this.getTotalCorrectAnswers()
                },
                html = Mustache.render(templateQuestion, newData);

            this.pane.innerHTML = html;
            updateControls(this.totalQuestions, this.checkShowResult, this.nextQuestionButton, this.previousQuestionButton, this.resultButton, this.newExamButton);
        });
    }

    startExam(exam, examName, examNameRule) {
        this.initExam(exam, examName, examNameRule);
        this.renderQuestion(false);
    }

    /* == PUBLIC METHODS ==================================================== */
}

/* == PUBLIC API ============================================================ */


/* ========================================================================== *\
    EXPORTS
\* ========================================================================== */

export default Exam;

/* == EXPORTS =============================================================== */